<nz-modal
  [nzWidth]="'800px'"
  [(nzVisible)]="isNewEditGoalVisible"
  (nzVisibleChange)="onIsNewEditGoalVisibleChange($event)"
  [nzTitle]="isEditGoal ? 'Edit Target Position' : 'Add New Target Position'"
  (nzOnCancel)="onCancelGoalClick()"
  [nzOkText]="null"
  [nzCancelText]="null"
>
  <ng-container *nzModalContent>
    <form nz-form [nzLayout]="'vertical'" [formGroup]="validateForm" (ngSubmit)="submitForm()">
      <nz-form-item>
        <nz-form-label nzRequired nzFor="company">Company</nz-form-label>
        <nz-form-control nzErrorTip="Company required.">
          <input nz-input formControlName="company" id="company" [placeholder]="'Your target company'" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzRequired nzFor="position">Position</nz-form-label>
        <nz-form-control nzErrorTip="Position required, e.g., Software Engineer.">
          <input nz-input formControlName="position" id="position" [placeholder]="'Your target position'" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzRequired nzFor="companyDetails">Company Information</nz-form-label>
        <nz-form-control nzErrorTip="Company details required.">
          <textarea
            nz-input
            formControlName="companyDetails"
            rows="5"
            id="companyDetails"
            [placeholder]="
              'The more information you share about the target company, the better the AI assistant can tailor your responses to help you ace the interview questions.'
            "
          ></textarea>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzRequired nzFor="jobDescription">Job Description & Requirement</nz-form-label>
        <nz-form-control nzErrorTip="Job description required.">
          <textarea
            nz-input
            formControlName="jobDescription"
            rows="5"
            id="jobDescription"
            [placeholder]="
              'The more specific details you share about the job description and requirements, the better the AI assistant can tailor your responses to help you ace the questions.'
            "
          ></textarea>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-control>
          <button nz-button [nzType]="'primary'" class="submit-button">{{ isEditGoal ? 'Save' : 'Create' }}</button>
        </nz-form-control>
      </nz-form-item>
    </form>
  </ng-container>
</nz-modal>
